export default __webpack_public_path__ + "static/media/logo-singular.ab138f61.png";